export const formatPhoneNumber = number => {
  if (number.substring(0, 3) === "+48") {
    return `${number.substring(0, 3)} ${number.substring(3, 6)} ${number.substring(
      6,
      9,
    )} ${number.substring(9)}`
  }

  return `${number.substring(0, 3)} ${number.substring(3, 6)} ${number.substring(6)}`
}

export const makeid = (length = 10) => {
  var result = ""
  var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789"
  var charactersLength = characters.length
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
  }
  return result
}
